const FIREBASE_PREVIEW_HOST_PATTERN = /^(taskid-\d+)--.+\.(web\.app|firebaseapp\.com)$/i;

export function isFirebasePreviewHost(hostname?: string): boolean {
  const resolvedHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  return FIREBASE_PREVIEW_HOST_PATTERN.test(resolvedHostname);
}

export function getFirebasePreviewChannelId(hostname?: string): string | null {
  const resolvedHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  const match = resolvedHostname.match(FIREBASE_PREVIEW_HOST_PATTERN);
  return match?.[1]?.toLowerCase() ?? null;
}